<template>
  <main-template>
    <abstract-submission-receipt
      class="self"
      :header="'termsAndConditions.reviewSubmission.header'"
      :reason="'termsAndConditions.reviewSubmission.reason'"
      :title="'termsAndConditions.reviewSubmission.title'">
      <div>
        {{ $t('termsAndConditions.reviewSubmission.highLight')}} : {{ receiptNumber }}
      </div>
    </abstract-submission-receipt>
  </main-template>
</template>

<script setup lang="ts">
    import { ref } from 'vue'
    import { useRoute } from 'vue-router'
    import MainTemplate from '@/components/MainTemplate.vue'
    import AbstractSubmissionReceipt from '@/components/reviewSubmission/AbstractSubmissionReceipt.vue'

    const route = useRoute()

    const receiptNumber = ref(route.params.receiptNumber as string)

    const updateReceipt = (newReceiptNumber: string) => {
        receiptNumber.value = newReceiptNumber
    }

    defineExpose({ updateReceipt })
</script>

<style scoped>
</style>
